'use client';

import { useEffect, useState } from 'react';
import { c } from '../../../utils/tailwind-merge';
import { ProductRating } from '../ProductRating';
import { ProductReviews } from '../ProductReviews';
import { ReviewListProps } from './ReviewList.types';

export const ReviewList = ({
  microcopy,
  className,
  reviewStars,
  reviewList,
  canWriteReview,
  onFilterReviews,
  onWriteReview,
  onEditReply,
  onDeleteReply,
  onEditReview,
  onDeleteReview,
  onSubmitReport,
  onSubmitReply,
  onSort,
  onPageChange,
  onFilter,
  onHelpfulVotesReview,
  onHelpfulVotesReply,
  onSubmitReview,
  onEmailPublisher,
  reviews,
  start,
  end,
  total,
  currentPage,
  totalPages,
  writeReviewModal,
}: ReviewListProps) => {
  const [reviewsOnLoad, setReviewsOnLoad] = useState(reviews);

  useEffect(() => {
    setReviewsOnLoad(reviews);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className={c(className)}>
      {reviewsOnLoad.length ? (
        <ProductRating
          reviewList={reviewList}
          reviewStars={reviewStars}
          canWriteReview={canWriteReview}
          writeReviewModal={{
            imageUrl: writeReviewModal.imageUrl,
            title: writeReviewModal.title,
            ownedDate: writeReviewModal.ownedDate,
            data: writeReviewModal.data,
            version: writeReviewModal.version,
          }}
          onFilterReviews={onFilterReviews}
          onWriteReview={onWriteReview}
          onSubmitReview={onSubmitReview}
          onEmailPublisher={onEmailPublisher}
          microcopy={{
            ...microcopy.productRating,
          }}
          className="mb-8"
        />
      ) : null}

      <ProductReviews
        microcopy={microcopy.productReviews}
        writeReviewModal={writeReviewModal}
        reviews={reviews}
        start={start}
        end={end}
        total={total}
        currentPage={currentPage}
        totalPages={totalPages}
        reviewsOnLoad={reviewsOnLoad}
        onHelpfulVotesReview={onHelpfulVotesReview}
        onEditReview={onEditReview}
        onDeleteReview={onDeleteReview}
        onHelpfulVotesReply={onHelpfulVotesReply}
        onEditReply={onEditReply}
        onDeleteReply={onDeleteReply}
        onSubmitReply={onSubmitReply}
        onFilter={onFilter}
        onSort={onSort}
        onPageChange={onPageChange}
        onSubmitReport={onSubmitReport}
        onEmailPublisher={onEmailPublisher}
        onSubmitReview={onSubmitReview}
      />
    </section>
  );
};
